import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide({triggerButton, title, disabledTrigger, onTriggerClick, description, okButtonText, cancelButtonText, onConfirm, onDismiss, primary}:any) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button variant={primary ? 'contained' : 'outlined'} size="large" className="fullwidth" disabled={disabledTrigger} 
      sx={{borderRadius: '25px'}}
        onClick={() => {
          if(onTriggerClick) {
            onTriggerClick()
          }
          handleClickOpen()
        }}
      >
        {triggerButton}
      </Button>
      <Dialog
        open={open}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {cancelButtonText && 
            <Button variant="outlined" onClick={() => {
              if(onDismiss) {
                onDismiss()
              }
              handleClose()
            }}>{cancelButtonText}</Button>
          }
          {okButtonText && 
            <Button variant="contained" onClick={() => {
              if(onConfirm) {
                onConfirm(); 
              }
              handleClose();
            }}>{okButtonText}</Button>
          }
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}